import { render, staticRenderFns } from "./aiWords.vue?vue&type=template&id=123707f4"
import script from "./aiWords.vue?vue&type=script&lang=js"
export * from "./aiWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports